import { render, staticRenderFns } from "./PasswordsDialog.vue?vue&type=template&id=10e55ad9&"
import script from "./PasswordsDialog.vue?vue&type=script&lang=js&"
export * from "./PasswordsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports